import { SET_ALERT_MESSAGES } from "../actions/actionTypes";

export const messageAlertsReducer = (state = [], action) => {
    switch (action.type) {
        case SET_ALERT_MESSAGES:
            return action.messages;
        default:
            return state;
    }
};